import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { downloadsRouting } from './downloads.routes';
import { DownloadsComponent } from './downloads.component';
import { FormsModule } from '@angular/forms';
import { FormModule } from '../../core/components/form/form.module';
import { TableModule } from '../../core/components/table/table.module';
import { FooterModule } from '../../core/components/footer/footer.module';


@NgModule({
  declarations: [DownloadsComponent],
  imports: [
    downloadsRouting,
    CommonModule,
    FormsModule, 
    FormModule, 
    TableModule,
    FooterModule
  ]
})
export class DownloadsModule { }
